import {
    algoliaAutofillTrack,
    trackLegacySearchEvent,
    trackSearchFlyoutClick,
    trackSubmitSearchEvent,
} from '@libs/analytics';

import type { ProductSearchItem } from '../search.types';
import { setSuggestedProductStats } from './set-suggested-product-stats';
import { storePdpFindingMethod } from './store-pdp-finding-method';

type TrackProductSelectionOptions = {
    item: ProductSearchItem;
    query: string;
    url: string;
};

export function trackProductSelection({ item, query, url }: TrackProductSelectionOptions) {
    if (item.masterProductUrl && item.queryId) {
        algoliaAutofillTrack({
            objectID: item.objectId,
            masterProductID: item.masterProductId,
            __autocomplete_id: item.legacyPosition,
            __autocomplete_queryID: item.queryId,
        });
    }
    setSuggestedProductStats(query);
    trackSearchFlyoutClick({ term: query, header: 'product results', url });
    trackSubmitSearchEvent(query, 'product results', query);
    trackLegacySearchEvent(item.label, 'product results');
    storePdpFindingMethod();
}
